import { render, staticRenderFns } from "./ProgramManagementList.vue?vue&type=template&id=e74df256&"
import script from "./ProgramManagementList.vue?vue&type=script&lang=js&"
export * from "./ProgramManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports